export const isReviewerPathAllowed = (path) => (
  path === '/'
  || path === '/profile'
  || path === '/generation/content'
  || path === '/orders'
  || path.startsWith('/orders/')
);
